// extracted by mini-css-extract-plugin
module.exports = {"section":"examplesWrapper_section__Utk5I","title":"examplesWrapper_title__cvY9y","wrapper":"examplesWrapper_wrapper__x6WEr"};